(function () {
  "use strict";

  function initShellNav() {
    var shellHeader = document.querySelector("[data-shell-header]");
    var headerInner = shellHeader ? shellHeader.querySelector(".wb-header-inner") : null;
    var logo = shellHeader ? shellHeader.querySelector(".wb-logo") : null;
    var desktopNav = shellHeader ? shellHeader.querySelector(".wb-nav") : null;
    var navActions = shellHeader ? shellHeader.querySelector(".wb-nav-actions") : null;
    var toggle = document.querySelector("[data-shell-nav-toggle]");
    var panel = document.querySelector("[data-shell-nav-panel]");
    var desktopMedia = window.matchMedia("(min-width: 761px)");
    var desktopWideMedia = window.matchMedia("(min-width: 1385px)");

    if (!toggle || !panel) {
      return;
    }

    /* Das Panel wandert an den KOERPER, raus aus dem sticky Header.
       Grund: Als fest positioniertes Kind eines `position: sticky`-Vorfahren
       nahm iOS Safari die Wischbewegung nicht an — in Chrome scrollte es
       einwandfrei, am iPhone „ueberhaupt nicht" (Alex, 31.07.). Ein Overlay
       direkt am body hat keinen sticky- und keinen overflow-Vorfahren mehr,
       damit faellt diese ganze Fehlerklasse weg.
       Die Klick-Listener unten haengen an den Links selbst und ueberleben den
       Umzug; die Breitenregeln aus wb-shell.css hingen am Header-Container und
       sind hier nicht mehr noetig (das Overlay ist ohnehin randlos). */
    if (panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }

    function setOpen(isOpen) {
      toggle.setAttribute("aria-expanded", String(isOpen));
      toggle.setAttribute(
        "aria-label",
        isOpen
          ? toggle.getAttribute("data-label-close")
          : toggle.getAttribute("data-label-open")
      );
      panel.hidden = !isOpen;
      panel.classList.toggle("is-open", isOpen);
      document.body.classList.toggle("shell-nav-open", isOpen);
      if (isOpen) {
        updatePanelOffset();
      } else {
        panel.style.removeProperty("--wb-mobile-panel-top");
      }
    }

    function updatePanelOffset() {
      // Das Panel ist ein am Viewport verankertes Overlay (CSS: position fixed,
      // top von hier, bottom 0). Hier wird nur sein OBERRAND gesetzt, nicht die
      // Höhe — die ergibt sich aus top/bottom.
      //
      // Vorher stand hier `maxHeight = innerHeight - panelTop - 8`. Auf dem
      // iPhone war das der Fehler: Safari klappt seine Toolbar ein und aus,
      // der einmal gemessene Wert stimmt sofort nicht mehr, das Menü war zu
      // hoch und die unteren Punkte nicht erreichbar (Alex, 31.07.).
      // Deshalb kein Rechnen mit der Fensterhöhe mehr, und der Oberrand wird
      // live nachgezogen: der Header ist sticky, seine Unterkante wandert.
      if (!panel.classList.contains("is-open")) return;
      var anchor = headerInner || toggle;
      if (!anchor) return;
      var top = Math.round(anchor.getBoundingClientRect().bottom);
      panel.style.setProperty("--wb-mobile-panel-top", Math.max(0, top) + "px");
    }

    function updateDesktopNavMode() {
      if (!shellHeader || !headerInner || !logo || !desktopNav || !navActions) {
        return;
      }

      if (!desktopWideMedia.matches) {
        shellHeader.classList.remove("wb-header--compact-nav");
        return;
      }

      var logoRect = logo.getBoundingClientRect();
      var navRect = desktopNav.getBoundingClientRect();
      var actionsRect = navActions.getBoundingClientRect();
      var minSideClearance = 10;

      var leftClearance = navRect.left - logoRect.right;
      var rightClearance = actionsRect.left - navRect.right;

      var shouldCompact =
        leftClearance < minSideClearance ||
        rightClearance < minSideClearance;

      shellHeader.classList.toggle("wb-header--compact-nav", shouldCompact);

      if (!shouldCompact) {
        setOpen(false);
      }
    }

    setOpen(false);
    updateDesktopNavMode();

    toggle.addEventListener("click", function () {
      setOpen(toggle.getAttribute("aria-expanded") !== "true");
    });

    panel.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        setOpen(false);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setOpen(false);
      }
    });

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener("change", function (event) {
        if (event.matches) {
          setOpen(false);
        }
        updateDesktopNavMode();
      });
    } else if (desktopMedia.addListener) {
      desktopMedia.addListener(function (event) {
        if (event.matches) {
          setOpen(false);
        }
        updateDesktopNavMode();
      });
    }

    if (desktopWideMedia.addEventListener) {
      desktopWideMedia.addEventListener("change", updateDesktopNavMode);
    } else if (desktopWideMedia.addListener) {
      desktopWideMedia.addListener(updateDesktopNavMode);
    }

    window.addEventListener("resize", updateDesktopNavMode);

    if (window.ResizeObserver && headerInner) {
      new ResizeObserver(updateDesktopNavMode).observe(headerInner);
    }

    // Oberrand des offenen Menüs nachziehen. `visualViewport` ist der Grund,
    // warum es diese Listener gibt: nur dort meldet iOS Safari das Ein- und
    // Ausklappen seiner Toolbar. `scroll` deckt den Fall ab, dass die Topbar
    // beim Öffnen noch sichtbar war und danach weggescrollt wird.
    window.addEventListener("resize", updatePanelOffset);
    window.addEventListener("scroll", updatePanelOffset, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", updatePanelOffset);
      window.visualViewport.addEventListener("scroll", updatePanelOffset);
    }
  }

  function initSearchOverlay() {
    var overlay = document.querySelector("[data-shell-search-overlay]");
    if (!overlay) return;

    var openButtons = document.querySelectorAll("[data-shell-search-open]");
    var closeButtons = overlay.querySelectorAll("[data-shell-search-close]");
    var form = overlay.querySelector("[data-shell-search-form]");
    var input = overlay.querySelector("[data-shell-search-input]");
    var results = overlay.querySelector("[data-shell-search-results]");
    var status = overlay.querySelector("[data-shell-search-status]");
    var debounceTimer = null;
    var pendingRequest = null;

    function setOpen(isOpen) {
      overlay.hidden = !isOpen;
      document.body.classList.toggle("shell-nav-open", isOpen);
      if (isOpen && input) {
        input.focus();
      } else if (!isOpen) {
        resetResults();
      }
    }

    function setStatus(message) {
      if (!status) return;
      status.innerHTML = message;
    }

    function renderIdleState() {
      if (!results) return;
      results.innerHTML =
        '<div class="wb-search-results-empty"><p>Starte mit einem Suchbegriff und wir zeigen dir sofort passende Treffer.</p></div>';
      setStatus("Tippe, um Produkte, Kategorien und Inspirationen live zu sehen.");
    }

    function renderEmptyState(query) {
      if (!results) return;
      results.innerHTML =
        '<div class="wb-search-results-empty"><p>Keine Live-Treffer für &bdquo;' +
        escapeHtml(query) +
        '&ldquo;. Versuche einen anderen Begriff.</p></div>';
      setStatus("Keine direkten Treffer gefunden.");
    }

    function resetResults() {
      if (pendingRequest) {
        pendingRequest.abort();
        pendingRequest = null;
      }
      if (debounceTimer) {
        window.clearTimeout(debounceTimer);
        debounceTimer = null;
      }
      if (input) {
        input.value = "";
      }
      renderIdleState();
    }

    function escapeHtml(value) {
      return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }

    function fetchPredictiveResults(query) {
      if (!results || !window.routes || !routes.predictive_search_url) return;

      if (pendingRequest) {
        pendingRequest.abort();
      }

      pendingRequest = new AbortController();
      setStatus("Suche läuft...");

      fetch(
        routes.predictive_search_url +
          "?q=" +
          encodeURIComponent(query) +
          "&resources[limit]=4&resources[limit_scope]=each&section_id=livesearch",
        { signal: pendingRequest.signal }
      )
        .then(function (response) {
          if (!response.ok) {
            throw new Error(String(response.status));
          }
          return response.text();
        })
        .then(function (markup) {
          var parsed = new DOMParser().parseFromString(markup, "text/html");
          var section = parsed.querySelector("#shopify-section-livesearch");
          var resultsMarkup = section ? section.innerHTML.trim() : "";

          if (!resultsMarkup) {
            renderEmptyState(query);
            return;
          }

          results.innerHTML = resultsMarkup;
          setStatus("Live-Ergebnisse für <span class='highlight'>" + query + "</span>.");
        })
        .catch(function (error) {
          if (error.name === "AbortError") {
            return;
          }
          renderEmptyState(query);
        })
        .finally(function () {
          pendingRequest = null;
        });
    }

    function schedulePredictiveResults() {
      if (!input) return;

      var query = input.value.trim();
      if (debounceTimer) {
        window.clearTimeout(debounceTimer);
      }

      if (!query) {
        renderIdleState();
        return;
      }

      debounceTimer = window.setTimeout(function () {
        fetchPredictiveResults(query);
      }, 180);
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        setOpen(true);
      });
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        setOpen(false);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setOpen(false);
      }
    });

    if (input) {
      input.addEventListener("input", schedulePredictiveResults);
    }

    if (results && input) {
      results.addEventListener("click", function (event) {
        var suggestion = event.target.closest("[data-search-suggestion]");
        if (!suggestion) return;

        event.preventDefault();
        input.value = suggestion.getAttribute("data-search-suggestion") || "";
        schedulePredictiveResults();
      });
    }

    if (form && input) {
      form.addEventListener("submit", function () {
        if (!input.value.trim()) {
          input.focus();
        }
      });
    }

    renderIdleState();
  }

  function initAnwendungsgebieteTextOnly() {
    var path = (window.location && window.location.pathname) || "";
    if (!/\/anwendungsgebiete\/?$/i.test(path)) {
      return;
    }

    document.body.classList.add("template-page-anwendungsgebiete");

    var firstSection = document.querySelector("#content .shopify-section .m6as");
    if (!firstSection) {
      return;
    }

    firstSection.classList.add("anwendungsgebiete-links-layout");

    Array.prototype.slice.call(firstSection.children).forEach(function (node) {
      if (node.tagName === "FIGURE") {
        node.remove();
      }
    });
  }

  function init() {
    initShellNav();
    initSearchOverlay();
    initAnwendungsgebieteTextOnly();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
